import z from "zod";
export function calcularAvisoPrevio(
  tempoTrabalhadoAnos: number,
  ValorBruto: number
): number {
  let diasAviso = 30;

  if (tempoTrabalhadoAnos > 1) {
    const anosExtras = Math.floor(tempoTrabalhadoAnos) - 1;
    diasAviso += anosExtras * 3;
  }

  if (diasAviso > 90) {
    diasAviso = 90;
  }
  let avisoPrevio = ValorBruto * (diasAviso / 30);

  return avisoPrevio;
}
export function CalcularFGTS(
  ValorBruto: number,
  AnoFinal: number,
  MesFinal: number,
  AnoInicial: number,
  MesInicial: number
) {
  let depositomensal = ValorBruto * 0.08;
  let meses = (AnoFinal - AnoInicial) * 12 + (MesFinal - MesInicial) + 1;
  let depositoTotal = depositomensal * meses;
  let valorFgts = depositoTotal;
  return valorFgts;
}
export const schema = z.object({
  salariobruto: z.string().nonempty("Adcione um valor ao Salario Bruto"),
  contrataçao: z.string().nonempty("Adcione uma data de contratação"),
  demissao: z.string().nonempty("Adcione uma data de demissão"),
  dependentes: z.string().nonempty("Adcione um valor ao Dependentes"),
  fgts: z.string().nonempty("Informe um valor ao FGTS"),
  feriasDias: z.string().nonempty("Adcione um valor a Ferias Vencidas"),
  motivo: z.string(),
  aviso: z.string(),
});

export interface DataType {
  salariobruto: string;
  contrataçao: string;
  demisao: string;
  motivo: string;
  aviso: string;
  dependentes: number;
  FGTS: string;
  feriasDias: number;
}
export const valoresLocalStorage = {
  salariobruto: localStorage.getItem("salario") || "",
  contrataçao: localStorage.getItem("contrataçao") || "",
  demissao: localStorage.getItem("demissao") || "",
  dependentes: localStorage.getItem("dependentes") || "",
  fgts: localStorage.getItem("fgts") || "",
  feriasDias: localStorage.getItem("ferias") || "",
  motivo: localStorage.getItem("motivo") || "comunAcordo",
  aviso: localStorage.getItem("aviso") || "valor1",
  tempoRestante: localStorage.getItem("tempoRestante") || "",
};
export interface RescisaoTrabalhistaResponse {
  rescisao: number;
  multaFGTS: number;
  FGTS: number;
  saldoSalario: number;
  decimoProporcional: number;
  feriasVencidas: number;
  avisoPrevio: number;
}
export interface RescisaoResult {
  rescisao: number;
  multaFGTS: number;
  FGTS: number;
  saldoSalario: number;
  decimoProporcional: number;
  feriasVencidas: number;
  avisoPrevio: number;
}
export type FormDataProps = z.infer<typeof schema>;

export const handleSave = (data: FormDataProps) => {
  const newValue = data;
  localStorage.setItem("salario", newValue.salariobruto);
  localStorage.setItem("contrataçao", newValue.contrataçao);
  localStorage.setItem("demissao", newValue.demissao);
  localStorage.setItem("dependentes", newValue.dependentes);
  localStorage.setItem("fgts", newValue.fgts);
  localStorage.setItem("ferias", newValue.feriasDias);
  localStorage.setItem("motivo", newValue.motivo);
  localStorage.setItem("aviso", newValue.aviso);
};